var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"ui-toast-list component",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.toastsList),function(item){return _c('UiToast',{key:item.id,attrs:{"item":item},on:{"remove":_vm.onRemove}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e432dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiToastList.vue
// module id = null
// module chunks = 